<template>
  <v-container>
    <v-card
      class="mx-auto"
      max-width="1000"
    >
      <v-card-title>
        {{ question.Question }}
      </v-card-title>
      <v-card-actions>
        <v-row dense>
          <v-col v-for="(answer, index) in question.answers" :key=index>
            <v-card @click="handleAnswer(answer)" 
              :color=isCorrectAnswer(index)
              :class="{'disable-buttons': currentUserAnswer ? true : false}">
              <v-card-text>{{ answer }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-expand-transition>
        <div v-show="show">
          <v-divider></v-divider>
          <v-card-text>
              {{ question.Answer }}
          </v-card-text>
          <v-row wrap>
            <v-col cols=5>
              <v-card-text><em>
                {{ question.References }}
              </em></v-card-text>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-card-text v-show="question.Source">Credit: {{ question.Source }}</v-card-text>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
      <v-card-actions>
        <v-btn small @click="nextQuestion" v-show="show">Next Question</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "QuestionCard",
  props: {
    question: Object,
    user: Object
  },
  methods: {
    nextQuestion() {
      this.$emit('nextQuestion', this.question.id, 
        this.currentUserAnswer === this.question.CorrectChoice);
      this.show = false;
      this.currentUserAnswer = null;
      this.chosenAnswer = null;
    },
    isCorrectAnswer(index) {
      if (
        !this.currentUserAnswer ||
        this.question.answers[index] != this.currentUserAnswer
      ) {
        return '';
      } else if (this.currentUserAnswer === this.question.CorrectChoice) {
        return 'green';
      } else {
        return 'red'
      }
    },
    handleAnswer(answer) {
      this.currentUserAnswer = answer;
      this.show = true;
    },
    disableButtons() {
      return this.currentUserAnswer;
    }
  },
  data() {
    return {
      show: false,
      currentUserAnswer: null
    };
  }
};
</script>

<style scoped>
.question {
  cursor: pointer;
}

.question:hover {
  background-color: blue;
}

.v-card__text,
.v-card__title {
  word-break: normal;
}

.answerRight {
  color: green;
}

.answerWrong {
  color: red;
}

.disable-buttons {
  pointer-events: none;
}
</style>
